import { AbsoluteModelPath } from "../../../Common/ModelPath/ModelPath";

export type HighlightingType = "bg-warning" | "border-warning";

export interface HighlightingOptions {
    highlightingType?: HighlightingType;
    tooltipText?: string;
    isTooltipFixed?: boolean;
}

export interface HighlightedControl<T> extends HighlightingOptions {
    pathMask: T;
}

export interface HighlightedControlWithFocus extends HighlightedControl<AbsoluteModelPath> {
    focused: boolean;
}

export const resolveHighlightingOptions = (options?: HighlightingOptions, isFocused?: boolean): HighlightingOptions => {
    if (!options) {
        return {
            highlightingType: undefined,
            isTooltipFixed: false,
            tooltipText: undefined,
        };
    } else if (isFocused) {
        return {
            highlightingType: "bg-warning",
            isTooltipFixed: true,
            tooltipText: options.tooltipText,
        };
    } else if (!options.highlightingType) {
        return {
            highlightingType: "border-warning",
            isTooltipFixed: false,
            tooltipText: options.tooltipText,
        };
    } else {
        return {
            highlightingType: options.highlightingType,
            isTooltipFixed: options.isTooltipFixed,
            tooltipText: options.tooltipText,
        };
    }
};
